import React, { useState, useEffect } from "react";
import { supabase } from "../../lib/supabase";

const FALLBACK = [
  require("../Images/23.jpg"),
  require("../Images/22.jpg"),
  require("../Images/25.jpg"),
  require("../Images/arts2.jpg"),
  require("../Images/24.jpg"),
];

export default function CarouselTop() {
  const [slides, setSlides] = useState([]);
  const [failed, setFailed] = useState(0);

  useEffect(() => {
    supabase
      .from("hero_slides")
      .select("image_url")
      .eq("published", true)
      .order("sort_order")
      .order("id")
      .then(({ data }) => {
        if (data && data.length > 0) setSlides(data.map(r => r.image_url));
      });
  }, []);

  const allFailed = slides.length > 0 && failed >= slides.length;
  const images = (slides.length > 0 && !allFailed) ? slides : FALLBACK;

  return (
    <div
      id="carouselDark"
      className="carousel carousel-dark slide"
      data-bs-ride="carousel"
    >
      <ol className="carousel-indicators">
        {images.map((_, i) => (
          <li
            key={i}
            data-bs-target="#carouselDark"
            data-bs-slide-to={i}
            className={i === 0 ? "active" : ""}
            aria-current={i === 0 ? "true" : undefined}
            aria-label={`Slide ${i + 1}`}
          />
        ))}
      </ol>

      <div className="carousel-inner">
        {images.map((src, i) => (
          <div key={i} className={`carousel-item${i === 0 ? " active" : ""}`} data-bs-interval="4000">
            <img
              src={src}
              className="d-index w-100 h-100 fluid responsive"
              alt={`Hero slide ${i + 1}`}
              style={{ objectFit: "cover" }}
              onError={() => setFailed(f => f + 1)}
            />
          </div>
        ))}
      </div>

      <button className="carousel-control-prev" type="button" data-bs-target="#carouselDark" data-bs-slide="prev">
        <span className="carousel-control-prev-icon" aria-hidden="true" />
        <span className="visually-hidden">Previous</span>
      </button>
      <button className="carousel-control-next" type="button" data-bs-target="#carouselDark" data-bs-slide="next">
        <span className="carousel-control-next-icon" aria-hidden="true" />
        <span className="visually-hidden">Next</span>
      </button>
    </div>
  );
}
